export type PayCodeResponse = {
	id: number
	trade: string
	classification: string
	skillCode: string | null
	stCode: string | null
	otCode: string | null
	dtCode: string | null
	ttCode: string | null
	nspCode: string | null
	stRate?: number | null
	otRate?: number | null
	dtRate?: number | null
	ttRate?: number | null
	nspRate?: number | null
	projectId: number | null
}

export type EmployeePayCodeResponse = {
	id: number
	trade: string
	classification: string
	skillCode: string | null
	stCode: string | null
	otCode: string | null
	dtCode: string | null
	ttCode: string | null
	nspCode: string | null
	projectId: number | null
}

export const formatPayCodeOptionLabel = (payCode: EmployeePayCodeResponse): string => {
	const trade = payCode.trade?.trim() ?? ''
	const classification = payCode.classification?.trim() ?? ''
	if (trade && classification) return `${trade} - ${classification}`
	return trade || classification || `Pay code ${payCode.id}`
}

export const comparePayCodesForDisplay = (
	a: EmployeePayCodeResponse,
	b: EmployeePayCodeResponse,
): number => {
	const byTrade = a.trade.localeCompare(b.trade)
	if (byTrade !== 0) return byTrade
	return a.classification.localeCompare(b.classification)
}

export type PayCodeUpsertRequest = {
	trade: string
	classification: string
	skillCode: string | null
	stCode: string | null
	otCode: string | null
	dtCode: string | null
	ttCode: string | null
	nspCode: string | null
	stRate: number
	otRate: number
	dtRate: number
	ttRate: number
	nspRate: number
}
